import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import parser from "html-react-parser";
import "./index.css";

export default function AngelAi({angelAiLink}) {
    const imgCDNURL = process.env.REACT_APP_CDN + "eaimortgage/images/";

    const features = [
        "Credit Boost - No Service Fees*",
        "Expert and 100% trusted source of financial advice",
        "Start Your loan application stress free",
        "Connect with a Realtor<sup>®</sup>",
        "On-demand TRU Approval<sup>®</sup>",
        "Find a Down Payment Assistance Program",
        "Connect from the comfort of your home or on the go",
        "Speaks Your Language",
        "Affordability Advice",
        "Property Value Estimator",
        "Refinance Advice",
        "Rent Vs Buy Advice",
        "Available 24/7 <br/>And More!",
    ];

    return (
        <section className="angelai-section">
            <Container>
                <Row className="angelai-row">
                    <Col sm={12} md={12} lg={6} xl={6} className="text-center angelai-col">
                        <a
                            href="https://askangel.ai/evolution"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="AngelAi"
                        >
                            <Image
                                src={imgCDNURL + "angel-ai-mockup.webp"}
                                alt="AngelAi"
                                width="374px"
                                height="681px"
                                className="img-fluid angelai-img"
                                loading="lazy"
                            />
                        </a>
                    </Col>
                    <Col sm={12} md={12} lg={6} xl={6} className="angelai-features">
                        <h2 className="angelai-heading">{parser(angelAiLink)}, A Giant Leap Forward</h2>
                        <ul className="angelai-feature-list">
                            {features.map((feature, index) => (
                                <li key={index} className="angelai-feature-item">
                                    {index === 1 ? (
                                        <a
                                            href="https://askangel.ai/evolution"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label="AngelAi"
                                            className="angelai-feature-link"
                                        >
                                            {parser(feature)}
                                        </a>
                                    ) : (
                                        parser(feature)
                                    )}
                                </li>
                            ))}
                        </ul>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
